import { useFeatureFlag, useFeatureFlagsReady } from '../../contexts/featureFlagContext';
/** Growth redesign record shell (FND-17). Off = today's shell. */ export const RECORD_SHELL_FLAG = 'growth_record_shell_v1';
/** True only once flags are loaded and the flag is on (never flashes the new shell). */ export function useRecordShellEnabled() {
    const ready = useFeatureFlagsReady();
    const on = useFeatureFlag(RECORD_SHELL_FLAG);
    return ready && on === true;
}
/**
 * Proposal record shell (FND-20). Proposal v2 is unconditional (OD-60), so this
 * is the record shell flag alone; the separate name keeps proposal call sites stable.
 */ export function useProposalRecordShellEnabled() {
    return useRecordShellEnabled();
}
